<script>
import axios from '@/utils/axios';
import { Offcanvas } from 'bootstrap';

export default {
  emits: ['updated'],
  data() {
    return {
      saving: false,
      form: { date: '', requested_punch_in: '', requested_punch_out: '', reason: '' },
      errors: {},
      oc: null,
    };
  },
  computed: {
    todayStr() {
      const t = new Date();
      return `${t.getFullYear()}-${String(t.getMonth() + 1).padStart(2, '0')}-${String(t.getDate()).padStart(2, '0')}`;
    },
  },
  methods: {
    // parent isse call karta hai: this.$refs.createModal.open()
    open(prefill = {}) {
      this.reset();
      if (prefill.date) this.form.date = prefill.date;
      this.oc = Offcanvas.getOrCreateInstance(this.$refs.oc);
      this.oc.show();
    },
    close() { this.oc?.hide(); },
    reset() {
      this.form = { date: '', requested_punch_in: '', requested_punch_out: '', reason: '' };
      this.errors = {};
    },
    validate() {
      const e = {};
      if (!this.form.date) e.date = 'Date is required';
      if (!this.form.requested_punch_in) e.requested_punch_in = 'Required';
      if (!this.form.requested_punch_out) e.requested_punch_out = 'Required';
      if (!this.form.reason.trim()) e.reason = 'Reason is required';
      this.errors = e;
      return Object.keys(e).length === 0;
    },
    // "13:30" -> "13:30:00" (backend H:i:s maangta hai)
    toHMS(t) { return t ? (t.length === 5 ? t + ':00' : t) : t; },

    async submit() {
      if (!this.validate()) return;
      this.saving = true;
      try {
        const payload = {
          date: this.form.date,
          requested_punch_in: this.toHMS(this.form.requested_punch_in),
          requested_punch_out: this.toHMS(this.form.requested_punch_out),
          reason: this.form.reason,
        };
        const res = await axios.post('/hrms/attendances/regularization', payload);
        this.$swalToast(res.data.message || 'Regularization request submitted.');
        this.$emit('updated');
        this.close();
        this.reset();
      } catch (error) {
        this.$swalToast(error.message, 'error');
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<template>
  <div ref="oc" class="offcanvas offcanvas-end reg-oc" tabindex="-1" id="hrm_regularization_create_modal">
    <div class="offcanvas-header">
      <div class="d-flex align-items-center gap-2">
        <span class="reg-oc-ico"><i class="ti ti-clock-edit"></i></span>
        <h5 class="offcanvas-title mb-0">New Regularization Request</h5>
      </div>
      <button type="button" class="btn-close" data-bs-dismiss="offcanvas"></button>
    </div>

    <div class="offcanvas-body">
      <!-- info -->
      <div class="reg-note mb-3">
        <i class="ti ti-info-circle"></i>
        <span>This is submitted for your own attendance. Only an employee account can create a request.</span>
      </div>

      <!-- Date -->
      <div class="mb-3">
        <label class="reg-lbl">Date <span class="text-danger">*</span></label>
        <input type="date" class="form-control" :max="todayStr" v-model="form.date" :class="{ 'is-invalid': errors.date }" />
        <div v-if="errors.date" class="reg-err">{{ errors.date }}</div>
      </div>

      <!-- Punch in / out -->
      <div class="row g-2 mb-3 reg-time-row">
        <div class="col-6">
          <label class="reg-lbl">Requested Punch In <span class="text-danger">*</span></label>
          <input type="time" class="form-control" v-model="form.requested_punch_in" :class="{ 'is-invalid': errors.requested_punch_in }" />
          <div v-if="errors.requested_punch_in" class="reg-err">{{ errors.requested_punch_in }}</div>
        </div>
        <div class="col-6">
          <label class="reg-lbl">Requested Punch Out <span class="text-danger">*</span></label>
          <input type="time" class="form-control" v-model="form.requested_punch_out" :class="{ 'is-invalid': errors.requested_punch_out }" />
          <div v-if="errors.requested_punch_out" class="reg-err">{{ errors.requested_punch_out }}</div>
        </div>
      </div>

      <!-- Reason -->
      <div class="mb-3">
        <label class="reg-lbl">Reason <span class="text-danger">*</span></label>
        <textarea class="form-control" rows="4" maxlength="500" v-model="form.reason" placeholder="Why does this need correcting?" :class="{ 'is-invalid': errors.reason }"></textarea>
        <div v-if="errors.reason" class="reg-err">{{ errors.reason }}</div>
        <div class="reg-count">{{ form.reason.length }}/500</div>
      </div>
    </div>

    <div class="reg-oc-footer">
      <button type="button" class="btn btn-light" data-bs-dismiss="offcanvas">Cancel</button>
      <button type="button" class="btn btn-primary" :disabled="saving" @click="submit">
        <span v-if="saving" class="spinner-border spinner-border-sm me-1"></span>
        {{ saving ? 'Submitting…' : 'Submit Request' }}
      </button>
    </div>
  </div>
</template>

<style scoped>
.reg-oc { width: 440px; max-width: 92vw; }
.offcanvas-header { border-bottom: 1px solid #f1f5f9; padding: 18px 22px; }
.offcanvas-title { font-size: 16px; font-weight: 700; color: #0f172a; }
.reg-oc-ico {
  width: 36px; height: 36px; border-radius: 10px; flex-shrink: 0;
  background: linear-gradient(135deg, #4f46e5, #7c3aed); color: #fff;
  display: inline-flex; align-items: center; justify-content: center; font-size: 18px;
}
.offcanvas-body { padding: 22px; }

.reg-note {
  display: flex; gap: 8px; align-items: flex-start;
  background: #fffbeb; border: 1px solid #fde68a; color: #92400e;
  font-size: 12px; line-height: 1.45; padding: 11px 13px; border-radius: 10px;
}
.reg-note i { font-size: 15px; flex-shrink: 0; margin-top: 1px; }

.reg-lbl { font-size: 12px; font-weight: 600; color: #475569; margin-bottom: 5px; display: block; }
.form-control { border-radius: 10px; border-color: #e2e8f0; font-size: 13.5px; padding: 9px 12px; }
.form-control:focus { border-color: #a5b4fc; box-shadow: 0 0 0 3px rgba(79,70,229,.1); }
.reg-err { font-size: 11px; color: #dc2626; margin-top: 4px; }
.reg-count { font-size: 10.5px; color: #94a3b8; text-align: right; margin-top: 3px; }

/* Punch In/Out — spacing fix so fields don't touch */
.reg-time-row {
  --bs-gutter-x: 14px;
}
.reg-time-row input[type="time"] {
  padding: 9px 8px;
  font-size: 12.5px;
  min-width: 0;
}
.reg-time-row .reg-lbl {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
@media (max-width: 380px) {
  .reg-time-row .col-6 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .reg-time-row .col-6:first-child {
    margin-bottom: 10px;
  }
}

.reg-oc-footer {
  display: flex; justify-content: flex-end; gap: 10px;
  padding: 16px 22px; border-top: 1px solid #f1f5f9; margin-top: auto;
}
.reg-oc-footer .btn { border-radius: 10px; font-size: 13px; font-weight: 600; padding: 9px 18px; }
.btn-primary { background: linear-gradient(135deg, #4f46e5, #7c3aed); border: none; }
.btn-light { background: #f8fafc; border: 1px solid #e2e8f0; color: #475569; }
</style>